export { default } from "ember-style-modifier/modifiers/style";
